import type { CryptoAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { calculateCryptoPartInWallet } from "./partInWallet";

export const calculateCryptoExpectedYield = (
  userProduct: CryptoAsset,
  cashCurrency: Fiat,
  cryptoCurrency: Fiat
) => {
  const coins = userProduct?.cryptoData || [];
  const partsInWallet = calculateCryptoPartInWallet(
    userProduct,
    true,
    cashCurrency,
    cryptoCurrency
  );

  return coins.reduce((sum, current, index) => {
    const expectedYield = current?.predictedValueIncrease || 0;
    const partInWallet = partsInWallet?.[index] || 0;

    return sum + expectedYield * partInWallet;
  }, 0);
};
